module.exports = __webpack_public_path__ + "img/PLAINWHITE.af5b369e.png";